<template>
    <section class="hero is-unselectable">
        <div class="hero-body is-paddingless">
            <div class="banner-image mobile-hide" :class="pageRoute === 'home' || pageRoute === 'homeDeepLinked' ? 'homepage-banner' : 'program-banner'">
                <section v-if="pageRoute === 'home' || pageRoute === 'homeDeepLinked'" class="homepage-banner homepage-banner-container">
                    <div class="banner-title-block-container">
                        <h1 class="banner-title-block">{{ pageTitle }}</h1>
                    </div>
                </section>
                <section v-else class="program-banner program-banner-container">
                    <div class="banner-title-block-container">
                        <span class="page-title">{{ pageTitle }}</span>
                        <h2 v-if="program" class="program-title">{{ program.Title  }}</h2>
                        <h2 v-else class="program-title">{{ checkforTitle }}</h2>
                    </div>
                </section>
                <div class="image-wrapper" :class="[pageRoute === 'home' || pageRoute === 'homeDeepLinked' ? 'homepage-banner' : 'program-banner', pageRoute === 'phasing-overview' || pageRoute == 'course-overview' ? 'course-banner' : '']">
                    <img v-if="(pageRoute === 'home' || pageRoute === 'homeDeepLinked') && isExchange" src="../images/banner afbeelding exchange course catalogue.jpg" alt="Banner image for course catalogue">
                    <img v-else-if="pageRoute === 'home' || pageRoute === 'homeDeepLinked'" src="../images/banner afbeelding studiegids.jpg" alt="Banner image for exchange course catalogue">
                    <img v-else-if="pageRoute === 'phasing-overview' || pageRoute === 'course-overview'" src="../images/banner afbeelding courses.jpg" alt="Banner image for courses">
                    <img v-else-if="pageRoute === 'program-overview' || pageRoute === 'extra-uitdaging' || pageRoute === 'intellectueeleigendom' || pageRoute === 'disclaimer' || pageRoute === 'extra-educational-options' || pageRoute === 'archive' || pageRoute === 'privacy' || pageRoute === 'minoren'" src="../images/banner afbeelding program overview.jpg" alt="Banner image for program overview">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "ImageBanner",
        computed: {
        programKey() {
            const acYear = this.$route.params.acYear || (this.$store.state.acYears && this.$store.state.acYears.currentAcademicYear);
            const programSlug = this.$route.params.programSlug;
            return acYear && programSlug ? acYear + programSlug : null;
        },
        program() {
            return this.programKey ? this.$store.state.program[this.programKey]?.details : null;
        },
        pageRoute() {
            return this.$route.name;
        },
        pageContentKey() {
            const routeMap = {
                disclaimer: "disclaimer",
                intellectueeleigendom: "intellectueeleigendom",
                'extra-uitdaging': "ExtraUitdaging",
                'extra-educational-options': "ExtraUitdaging",
                browseroutdated: "BrowserOutdated",
                archive: "archief",
                privacy: "privacy",
                minoren: "minors"
            };
            return routeMap[this.$route.name];
        },
        checkforTitle() {
            const key = this.pageContentKey;
            return key && this.content[key] ? this.content[key].details.Title : null;
        },
        ...mapState(["content"])        
    },
    props: {
        pageTitle: {
            type: String,
            required: true
        }
    },
    created() {
        const key = this.pageContentKey;
        if (key) {
            this.$store.dispatch("getContent", key);
        }
	}
};
</script>

<style lang="less" scoped>
.hero {
    margin: 0px auto;
    min-height: 55px;
    max-height: 700px;
    overflow: hidden;
}
.hero-body.is-paddingless {
    padding: 0;
    display: flex;
    justify-content: center;
}
.banner-image {
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    width: 100vw;
    aspect-ratio: 2.88;
    max-width: 1600px;
}

.banner-image.homepage-banner {
    aspect-ratio: 2.88;
}

.banner-image.program-banner {
    aspect-ratio: 1440 / 400;
}
.homepage-banner-container {    
    display: flex;
}
.homepage-banner .banner-title-block-container {
    display: flex;
    padding: 32px;
    flex: 1;
    align-items: center;
    background-color: #25167A;
    width: 100%;
    aspect-ratio: 0.96 / 1;
}
.program-banner .banner-title-block-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background-color: white;
    padding: 40px 40px 8px 80px;
    width: 50%;
    min-height: 30%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
}
.page-title {
    font-weight: 800;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0%;
    color: #F35279;
}
.program-title {
    font-weight: 800;
    font-size: 40px;
    line-height: 48px;
    letter-spacing: -2%;
    color: #25167A;
}
.image-wrapper.homepage-banner {
    flex: 2;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}
.image-wrapper.program-banner {
    width: 100vw;
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}
.banner-image .homepage-banner img {
    max-width: 100%;
    height: auto;
    object-fit: cover;
    display: block;
}
.banner-image .program-banner img {
    width: 100vw;
    object-fit: cover;
    display: block;
    aspect-ratio: 1440 / 400;
}

.image-wrapper.homepage-banner::after {
    content: "";
    background: url(../../src/images/Driehoeken.svg) no-repeat right center;
    background-size: auto 100%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 40vw;
    min-width: 200px;
    max-width: 600px;
    height: 100%;
    z-index: 10;
    pointer-events: none;    

}

.banner-image.program-banner::after {
    content: "";
    background: url(../../src/images/DriehoekenProgramOverview.svg) no-repeat right center;
    background-size: auto 100%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 40vw;
    min-width: 200px;
    max-width: 600px;
    height: 100%;
    z-index: 10;
    pointer-events: none;    
} 

.course-banner {    
    align-items: flex-end !important;    
}

.course-banner img {
    aspect-ratio: 2.2 !important;
}


@media only screen and (max-width: 767px) {
    .banner-image {
        flex-direction: column !important;
        flex-wrap: nowrap;
        width: 100vw !important;
        aspect-ratio: unset !important;
        align-items: stretch !important;
    }
    .banner-title-block-container {
        aspect-ratio: unset !important;
    }
    .program-banner .banner-title-block-container {
        width: 95%;
        height: unset;
        padding: 24px 16px 8px 16px;
    }
    .page-title {
        font-size: 16px;
        line-height: 24px;
    }
    .program-title{
        font-size: 24px;
        line-height: 32px;
    }
    .banner-title-block {
        width: 100%;
    }
    .image-wrapper {
        position: relative;
        overflow: hidden;
    }
    .banner-image .homepage-banner img {
        width: 100%;
        height: 53vw;
        object-fit: cover;
        object-position: center;
        display: block;
    }
    .banner-image .program-banner img{
        aspect-ratio: unset;
    }
    .banner-image.program-banner::after{
        height: 50%;
    }
}
</style>